import { fetchApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_reactions'

type Operation = operations['messenger_get_reaction_list_getReactionList']
type Response = Operation['responses']['200']['schema']

export const fetchReactionListApi = () => {
  return fetchApi<Response>('/messenger/reactions')
}
